import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'axios'

import { connect } from "react-redux"

import {
    Modal,
    InputBase,
    IconButton,
} from '@material-ui/core'
import { Close, Search } from '@material-ui/icons'

import './SearchDialog.css'

const SearchDialog = (props) => {
    const { translation } = props

    const [query, setQuery] = useState('')
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const history = useHistory()

    useEffect(() => {
        setIsLoading(true)

        axios('/search/?query=' + query)
            .then((res) => {
                setProducts(res.data)
            })
            .finally(setIsLoading(false))
    }, [query])

    const handleSelectProduct = (e, p) => {
        history.push('/products/' + p.id)
        props.onClose(e)
    }

    const searchLabel = {
        "search_ua": "Пошук...",
        "search_ru": "Поиск..."
    }

    const closeLabel = translation.language === "ua" ? "Закрити пошук" : "Закрыть поиск"

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <div className="SearchDialog" tabIndex={-1} role="dialog" aria-label={translation.translateKey(searchLabel, "search")}>
                <form className="SearchDialog--bar" onSubmit={e => e.preventDefault()}>
                    <Search className="SearchDialog--icon" />
                    <InputBase
                        className="SearchDialog--input"
                        placeholder={translation.translateKey(searchLabel, "search")}
                        autoFocus
                        inputProps={{ 'aria-label': 'search products', type: 'search' }}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <IconButton
                        onClick={props.onClose}
                        aria-label={closeLabel}
                    >
                        <Close />
                    </IconButton>
                </form>

                {!isLoading && products && products.length > 0 && (
                    <ul className="SearchDialog--results">
                        {products.map((p) => {
                            return (
                                <li key={p.id}>
                                    <button
                                        type="button"
                                        onClick={(e) => handleSelectProduct(e, p)}
                                        className="SearchDialog--item"
                                    >
                                        <img
                                            className="SearchDialog--image"
                                            src={process.env.REACT_APP_API + '/media/' + p.picture.split(",")[0]}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <span className="SearchDialog--name">{translation.translateKey(p, "name")}</span>
                                        <span className="SearchDialog--price">{(p.with_action ? p.new_price : p.price).toLocaleString()} грн</span>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                )}
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => {
    return {
        translation: state.translationReducer
    }
}

export default connect(mapStateToProps)(SearchDialog)
